<template>
  <div v-if="visible" class="outer-carousel">
    <Transition name="pop" appear>
      <div v-if="visible" ref="popup" class="modal" role="dialog" aria-modal="true" tabindex="-1">
        <div class="modal-overlay">
          <div class="card-carousel">
            <div class="card-img">
              <img :src="currentImage" alt="" />
              <div v-show="displayControls" class="actions">
                <template v-if="images.length > 1">
                  <span
                    role="button"
                    tabindex="0"
                    class="prev"
                    @keydown.space.prevent
                    @keyup.space="nextImage"
                    @keydown.enter="nextImage"
                    @click="prevImage"
                  >
                    &#8249;
                  </span>
                  <span
                    role="button"
                    tabindex="0"
                    class="next"
                    @keydown.space.prevent
                    @keyup.space="nextImage"
                    @keydown.enter="nextImage"
                    @click="nextImage"
                  >
                    &#8250;
                  </span>
                </template>
              </div>
            </div>
            <button
              v-show="displayControls"
              :aria-label="modalCloseButtonAccessibleLabel"
              class="btn-close-modal"
              @click="closeModal"
            >
              X
            </button>
            <div v-if="activeThumbnails" class="thumbnails">
              <div
                v-for="(image, index) in images"
                :key="index"
                :class="['thumbnail-image', focusedPosition === index ? 'active' : '']"
                @click="activateImage(index)"
              >
                <img :src="image" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { trapFocus } from '../../../../../../../shared/utils/dom/focus';

export default {
  name: 'rfp-ratings-list-carousel-modal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mainPosition: {
      type: Number,
      default: 0,
    },
    images: {
      type: Array,
      default() {
        return [];
      },
    },
    showThumbnails: {
      type: Boolean,
      default: false,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    modalCloseButtonAccessibleLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      focusedPosition: this.mainPosition,
      displayControls: this.showActions,
    };
  },
  computed: {
    currentImage() {
      return this.images[this.focusedPosition];
    },
  },
  watch: {
    mainPosition(n) {
      this.activateImage(n);
    },
    async visible(newVal) {
      if (newVal) {
        await this.$nextTick();
        this.deactivateFocusTrap = trapFocus(this.$refs.popup);
      } else {
        this.deactivateFocusTrap();
        this.deactivateFocusTrap = null;
      }
    },
  },
  created() {
    this.focusedPosition = this.mainPosition;
  },
  mounted() {
    document.addEventListener('keydown', this.handleCloseOnEsc);
  },
  unmounted() {
    this.handleUnmounted();
  },
  destroyed() {
    this.handleUnmounted();
  },
  methods: {
    handleUnmounted() {
      document.removeEventListener('keydown', this.handleCloseOnEsc);
    },
    handleCloseOnEsc(event) {
      if (this.visible && event.key === 'Escape') {
        this.closeModal();
      }
    },
    nextImage() {
      this.focusedPosition + 1 >= this.images.length
        ? (this.focusedPosition = 0)
        : (this.focusedPosition += 1);
    },
    prevImage() {
      this.focusedPosition - 1 < 0
        ? (this.focusedPosition = this.images.length - 1)
        : (this.focusedPosition -= 1);
    },
    activateImage(e) {
      this.focusedPosition = e;
    },
    closeModal() {
      this.$emit('closedmodal');
    },
  },
};
</script>
